var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container iq-main-slider"},[_c('vue-plyr',{attrs:{"options":_vm.options}},[_c('video',{attrs:{"controls":"","data-poster":"logo.png","src":_vm.video.content_url}},[_c('source',{attrs:{"size":"720","src":_vm.video.content_url,"type":"video/mp4"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }